import React, { Component } from "react";
import PropTypes from "prop-types";
import { Breadcrumb, Col, Row } from "reactstrap";
import { withTranslation } from "react-i18next";

class Breadcrumbs extends Component {
  render() {
    return (
      <React.Fragment>
        <Row>
          <Col xs="12">
            <div className="page-title-box d-sm-flex align-items-center justify-content-between">
              <div className="page-title-right">
                <Breadcrumb listClassName="m-0">
                  {this.props.title} {this.props.title != "" ? "/" : " "}{" "}
                  <b
                    style={{
                      fontSize: "13px",
                      "marginLeft": "3px",
                      "marginTop": "-1px",
                    }}
                  >
                    {this.props.breadcrumbItem}
                  </b>
                </Breadcrumb>
              </div>
            </div>
          </Col>
        </Row>
      </React.Fragment>
    );
  }
}

Breadcrumbs.propTypes = {
  breadcrumbItem: PropTypes.string,
  title: PropTypes.string,
};
export default withTranslation()(Breadcrumbs);
